// extracted by mini-css-extract-plugin
export default {"cursor-container":"style_cursor-container__JYPBT"};